// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"ee60400d","321":"7d470ec9","403":"00ded880","453":"926f0775","488":"51a8ebaf","868":"d3267329","885":"e37e6827"}[chunkId] + ".chunk.js";
};